import { applyMiddleware, compose, legacy_createStore as createStore } from 'redux';
import thunk from 'redux-thunk';

import rootReducer from '../reducers/rootReducer';

export default function configureStore() {
  const middleware = [thunk];
  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const store = createStore(rootReducer, composeEnhancer(applyMiddleware(...middleware)));

  if (process.env.NODE_ENV === 'development') {
    window.store = store;
  }
  return store;
}

export const store = configureStore();
